/*=========================================================================================
  File Name: moduleSpaceActions.js
  Description: Space Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"
// import store from "../store.js"
// import router from '@/router'

export default {

    // Set mails flag unread to true
    createAnswer({ commit }, payload) {
      // commit("SET_ACTIVE_PROJECT_TITLE", payload.title)
      var noticeBoardInfo = {"answer": payload.answer, "workspace_id": payload.workspaceId, "id": payload.id}
      return new Promise((resolve, reject) => {
        axios.post("/api/workspace/qna-board/answer/update", noticeBoardInfo).then((response) =>{
          if(response.data.result == 'success'){
            commit("UPDATE_ANSWER", response.data.data)
            resolve(response)
          }
          reject(response)
        }).catch((error) => { reject(error) })
      })
    },
    createQuestion({ commit }, payload) {
      // commit("SET_ACTIVE_PROJECT_TITLE", payload.title)
      var noticeBoardInfo = {"question": payload.question, "workspace_id": payload.workspaceId}
      return new Promise((resolve, reject) => {
        axios.post("/api/workspace/qna-board/question/create", noticeBoardInfo).then((response) =>{
          if(response.data.result == 'success'){
            commit("CREATE_NOTICEBOARD", response.data.data)
            resolve(response)
          }
          reject(response)
        }).catch((error) => { reject(error) })
      })
    },
    updateQuestion({ commit }, payload) {
      var noticeBoardInfo = {"id": payload.id, "question": payload.question}
      return new Promise((resolve, reject) => {
        axios.post("/api/workspace/qna-board/question/update", noticeBoardInfo)
          .then((response) => {
            if(response.data.result == 'success'){
              commit("UPDATE_NOTICEBOARD", noticeBoardInfo)
              resolve(response)
            }
            reject(response)
          }
        )
        .catch((error) => { reject(error) })
      })
    },
    updateAnswer({ commit }, payload) {
      var noticeBoardInfo = {"id": payload.id, "answer": payload.answer}
      return new Promise((resolve, reject) => {
        axios.post("/api/workspace/qna-board/answer/update", noticeBoardInfo)
        .then((response) => {
          if(response.data.result == 'success'){
            commit("UPDATE_NOTICEBOARD", noticeBoardInfo)
            resolve(response)
          }
          reject(response)
        }).catch((error) => { reject(error) })
      })
    },
    deleteAnswer({ commit }, payload) {
      var noticeBoardInfo = {"id": payload.id, "answer": "", "workspace_id": payload.workspaceId}
      return new Promise((resolve, reject) => {
        axios.post("/api/workspace/qna-board/answer/update", noticeBoardInfo)
          .then((response) => {
            if(response.data.result == 'success'){
              commit("DELETE_NOTICEBOARD_ANSWER",  {"id": payload.id})
            }
            resolve(response)
          }
        )
        .catch((error) => { reject(error) })
      })
    },
    deleteQuestion({ commit }, payload) {
      var noticeBoardInfo = {"id": payload.id}
      return new Promise((resolve, reject) => {
        axios.delete("/api/workspace/qna-board/question/delete/"+payload.id)
          .then((response) => {
            if(response.data.result == 'success'){
              commit("DELETE_NOTICEBOARD_QUESTION", noticeBoardInfo)
            }
            resolve(response)
          }
        )
        .catch((error) => { reject(error) })
      })
    },
    getNoticeBoard({ commit }, payload) {
      // var projectInfo = {"project_id": payload.project_Id}
      return new Promise((resolve, reject) => {
        axios.get("/api/workspace/qna-board/"+payload)
          .then((response) => {
            if(response.data.result == 'success'){
              commit("SET_NOTICEBOARD_LIST", response.data.data_list)
            }
            resolve(response)
          }).catch((error) => { reject(error) })
        })
    }
}
